function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  width: 900,
  height: 600,
  fill: "#d7141a"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 900,
  height: 300,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 450,300 0,0 V 600 z",
  fill: "#11457e"
});

var SvgCz = function SvgCz(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 900 600"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/cz.65042957.svg";
export { SvgCz as ReactComponent };